import React from 'react'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import styled from 'styled-components'

import { Text } from '../Text'
import { Row, Column } from '../Grid'
import { ThinChevron } from '../../v2/Icons'

class CalendarFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false
    }
  }

  handleDatesChange(date) {
    this.props.handleDatesChange(date)
    this.setState({ focused: false })
  }

  render() {
    const { startDate } = this.props

    return (
      <DateContainer onClick={() => this.setState({ focused: !this.state.focused })}>
        <DatePicker cy_id='input-date' className='date-picker'>
          <Column pl='3px' width='100%'>
            <Text variant='small' textAlign='left' color='primary'>
              Escolha uma data
            </Text>
            <ContentDate>
              <SingleDatePicker
                readOnly
                date={moment(startDate)}
                onDateChange={date => this.handleDatesChange(date)}
                focused={this.state.focused}
                onFocusChange={() => this.setState({ focused: false })}
                noBorder={true}
                displayFormat='[A partir do dia] DD/MM'
                id='startDate'
                numberOfMonths={1}
                hideKeyboardShortcutsPanel
              />
            </ContentDate>
          </Column>
        </DatePicker>
        <ThinChevron height='16px' variant={!this.state.focused ? 'top' : 'down'} />
      </DateContainer>
    )
  }
}

const DateContainer = styled(Row)`
  cursor: pointer;
  border-radius: 2px;
  margin-bottom: 15px;
  align-items: center;
  background: white;
  border: 0.5px solid #bdc3c7;
  border-radius: 4px;
  height: 55px;
  justify-content: space-between;
  padding-right: 15px;

  @media (max-width: 770px) {
    margin: 10px 0;
    width: 100%;
  }
`
const DatePicker = styled.div`
  display: flex;
  box-shadow: 0;
  border: 0;
`
const ContentDate = styled.div`
  .DateInput {
    width: 100%;
  }
  .DateInput_input {
    width: 100% !important;
    cursor: pointer !important;
  }
  .DateInput_fangStroke {
    display: none;
  }
  .DateInput_fangShape {
    display: none;
  }
  .DayPickerNavigation {
    top: 0px !important;
  }
  .SingleDatePicker,
  .SingleDatePicker_1 {
    width: 100%;
  }
  .SingleDatePickerInput {
    width: 100%;
  }
  .SingleDatePicker_picker {
    top: 33px !important;
    left: 25px !important;

    @media (max-width: 425px) {
      left: 69px !important;
    }

    @media (max-width: 375px) {
      left: 20px !important;
    }

    @media (max-width: 360px) {
      left: 4px !important;
    }

    @media (max-width: 320px) {
      left: -13px !important;
    }
  }
  .DayPicker {
    width: 313px !important;
    @media (max-width: 320px) {
      width: 290px !important;
    }
  }
  .DayPicker_transitionContainer {
    width: 313px !important;
    @media (max-width: 320px) {
      width: 290px !important;
    }
  }
  .CalendarMonthGrid {
    @media (max-width: 320px) {
      left: 0px !important;
    }
  }
  .DayPicker_weekHeader {
    @media (max-width: 320px) {
      left: -10px !important;
    }
  }
  .DayPicker_weekHeader_li {
    @media (max-width: 320px) {
      width: 38px !important;
    }
  }
  .DayPicker_focusRegion {
    @media (max-width: 320px) {
      width: 290px !important;
    }
  }
`

export { CalendarFilter }
